<app-page-container>
    <div class="privacy-content">
      <div class="privacyHeader">
        <span [innerHtml]="'privacy' | translate"></span>
      </div>
      <div class="privacyText" [innerHtml]="privacyText">
      </div>
    </div>
</app-page-container>